import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from './redux'
import preload from 'components/enhancer/preload'
import composeHOC from 'shared/utils/composeHOC'
import DataGrid from 'components/grid/DataGrid'
import Meta from 'components/layout/Meta';

class Jobs extends Component {

  constructor(props) {
    super(props)
    const me = this
    this.state = {
      showDepartment: false,
      showProvince: false,
      showCity: false,
      showPublishTime: false,
      columns: [{
        field: 'name',
        label: '职位名称',
        width: 190
      }, {
        field: 'department',
        label: '工作部门',
        width: 220,
        render: (value) => {
          if (value === 1) {
            return '信息技术部'
          } else if (value === 2) {
            return '小花-技术'
          } else if (value === 3) {
            return '树读'
          }
        }
      }, {
        field: 'area_name',
        label: '工作地点',
        width: 213
      }, {
        field: 'publish_time',
        label: '发布时间',
        width: 187
      }],
      publishTimeList: [{
        id: 'all',
        name: '全部'
      }, {
        id: '3',
        name: '三天以内'
      }, {
        id: '7',
        name: '一周以内'
      }, {
        id: '14',
        name: '两周以内'
      }, {
        id: '30',
        name: '一个月内'
      }],
      departmentList: [{
        id: 1,
        name: '信息技术部'
      }, {
        id: 2,
        name: '小花-技术'
      }, {
        id: 3,
        name: '树读'
      }]
    }
  }
  componentDidMount(){

  }

  onSelectorClick = (selectorName) => {
    let obj = {}
    let hideSelect={showCity:false,
                    showDepartment:false,
                    showProvince:false,
                    showPublishTime:false}
    this.setState(hideSelect)
    obj[`show${selectorName}`] = !this.state[`show${selectorName}`]
    this.setState(obj)
  }

  onSelectProvince(province) {
    this.props.getCityList(province.id).then((result) => {
      this.setState({
        selectedCity: null,
        selectedProvince: province,
        cityList: result.data,
        showProvince: false
      })
    })
  }

  getParams() {

    const {
      selectedDepartment,
      selectedProvince,
      selectedCity,
      selectedPublishTime
    } = this.state

    let paramObj = {
      department: selectedDepartment && selectedDepartment.id,
      area: selectedCity ? selectedCity.id : (selectedProvince && selectedProvince.id)
    }

    if (selectedPublishTime && selectedPublishTime.id !== 'all') {
      paramObj.publishTime = selectedPublishTime.id
    }
    return paramObj
  }

  onSelectCity(city) {
    this.setState({
      selectedCity: city,
      showCity: false
    })
  }

  onSelectPublishTime(publishTime) {
    this.setState({
      selectedPublishTime: publishTime,
      showPublishTime: false
    })
  }

  onSelectDepartment(department) {
    this.setState({
      selectedDepartment: department,
      showDepartment: false
    })
  }

  searchJobs() {
    const params = {
      ...this.getParams(),
      page: this.props.jobPagination ? this.props.jobPagination.currentPage : 1
    }
    this.props.getJobList(params).then((result) => {
      this.setState({
        jobList: result.data.items,
        jobPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      })
    })
  }

  setPage(page) {
    const params = {
      ...this.getParams(),
      page
    }
    this.props.getJobList(params).then((result) => {
      this.setState({
        jobList: result.data.items,
        jobPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      })
    })
  }

  onJobClick(job) {
    let locations=window.location && window.location.host.split('.')
    if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地
      //this.props.router.push('http://www.chinatopcredit.com/recruitment/jobDetail/' + job.id)
      window.location.href="https://www.chinatopcredit.com/recruitment/jobDetail/"+job.id
    }else{
      this.props.router.push('/recruitment/jobDetail/' + job.id)
    }
  }

  render() {
    let {
      showDepartment,
      showProvince,
      showCity,
      cityList,
      showPublishTime,
      selectedProvince,
      selectedCity,
      selectedPublishTime,
      selectedDepartment,
      publishTimeList,
      departmentList,
      columns,
      jobList,
      jobPagination
    } = this.state

    if (!jobList) {
      jobList = this.props.jobList
      jobPagination = this.props.jobPagination
    }

    const {
      provinceList
    } = this.props

    return(
      <div className="rightCon jobRecruitment">
        <Meta location={this.props.location} title="职位招聘-招贤纳士"/>
        <div className="mgauto storeAddress">
          <h3>
            职位招聘
            <p>RECRUITMENT</p>
              <span className="redLine"></span>
          </h3>
          <div className="preInformation clearfix">
            <form action="/position/list.htm" method="post" id="pageinationForm">
              <div id="depSelect" className="select_box">
                <input
                   value={selectedDepartment && selectedDepartment.name}
                   onClick={this.onSelectorClick.bind(this, 'Department')} type="text" placeholder="工作部门" id="department" name="department" readOnly="readonly" />
                <div id="workDep" className="selectListArea" style={{display: showDepartment ? 'block' : 'none'}}>
                  <ul>
                    {departmentList && departmentList.map((department, i) => {
                      return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectDepartment.bind(this, department)}>{department.name}</a></li>)
                    })}
                  </ul>
                </div>
              </div>

              <div id="provinceSelect" className="select_box">
                <input type="text"
                  onClick={this.onSelectorClick.bind(this, 'Province')}
                  placeholder="选择省份"
                  readOnly="readonly"
                  name="province"
                  value={selectedProvince && selectedProvince.name} id="province" />
                <div id="workProvince"  className="selectListArea" style={{display: showProvince ? 'block' : 'none'}}>
                  <ul id="searchProvince">
                    {provinceList && provinceList.map((province, i) => {
                      return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectProvince.bind(this, province)}>{province.name}</a></li>)
                    })}
                  </ul>
                </div>
              </div>

              <div id="citySelect" className="select_box">
                <input type="text"
                  onClick={this.onSelectorClick.bind(this, 'City')} placeholder="选择城市" name="city" value={selectedCity && selectedCity.name} readOnly="readonly" id="city" />
                <div id="workCity" className="selectListArea" style={{display: showCity ? 'block' : 'none'}}>
                  <ul id="searchCity">
                    {cityList && cityList.map((city, i) => {
                      return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectCity.bind(this, city)}>{city.name}</a></li>)
                    })}
                  </ul>
                </div>
              </div>

              <div id="timeSelect" className="select_box">
                <input type="text" onClick={this.onSelectorClick.bind(this, 'PublishTime')} placeholder="发布时间" id="exhibition" value={selectedPublishTime && selectedPublishTime.name} readOnly />
                <div id="searchTime" className="selectListArea" style={{display: showPublishTime ? 'block' : 'none'}}>
                  <ul>
                    {publishTimeList && publishTimeList.map((publishTime, i) => {
                      return (<li key={i}><a style={{cursor: 'pointer'}} onClick={this.onSelectPublishTime.bind(this, publishTime)}>{publishTime.name}</a></li>)
                    })}
                  </ul>
                </div>
              </div>
            </form>
          <div className="searchBtn" id="btnSearch" onClick={this.searchJobs.bind(this)}></div>
        </div>

        {jobList &&
          <DataGrid
            onRowClick={this.onJobClick.bind(this)}
            setPage={this.setPage.bind(this)}
            columns={columns}
            items={jobList}
            linkPrefix={'/recruitment/jobRecruitment/'}
            pagination={jobPagination} />}


          <div className="addressDetail clearfix">
            <img src="/static/images/jobPic.jpg" />
            <dl>
              <dd>E-mail：zhaopin.hr@chinatopcredit.com</dd>
              <dd>HR联系电话：021-35967521</dd>
              <dd>地址：上海市虹口区四川北路859号中信广场18楼1805室</dd>
              <dd>邮编：200085</dd>
            </dl>
          </div>

        </div>
      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    jobList: state.recruitment.jobList,
    jobPagination: state.recruitment.jobPagination,
    provinceList: state.recruitment.provinceList
  }), actions),
  preload(({dispatch, location, routes}) => {
    const lastRoute = routes[routes.length - 1]
    const catname = lastRoute.catname || lastRoute.path
    return Promise.all([
      dispatch(actions.getProvinceList()),
      dispatch(actions.getJobList({page: 1}))
    ])
  })
)(Jobs)



// WEBPACK FOOTER //
// ./modules/recruitment/Jobs.js